<form
  action="/maps/229/api/update_capture/"
  method="post"
  class="content"
  [formGroup]="form"
  (submit)="create()"
  *ngIf="mapService.selectLayer"
>
  <h3
    style="background-size: 20px"

  >
    New Feature
  </h3>

  <div class="main-heading" style="background-size: 26px;"
  [ngStyle]="{
    'background-image': 'url(' + mapService.featureIcon + ')'
  }">{{captureLayerName}}</div>
  <ng-container *ngFor="let item of getCaptureFeatureData; let n = index">
    <ul class="fields">
      <li class="capture-li">
        <label class="label">{{ item.name }}</label
        ><input
          id="capture-id-{{ item.id }}"
          [formControlName]="item.name"
          *ngIf="
            item.type === 'string' &&
            item.visible === true &&
            (item.dropdown === false || !item.dropdown)
          "
          value="{{ item.name }}"
          class="value capture-input"
          type="text"
          name="field-{{ item.id }}"
        />
        <input
          *ngIf="item.type === 'number' && item.visible === true"
          [formControlName]="item.name"
          value="{{ item.name }}"
          class="date value"
          type="number"
          name="field25479"
        />
        <input
          *ngIf="item.type === 'integer' && item.visible === true"
          [formControlName]="item.name"
          value="{{ item.name }}"
          class="date value"
          type="integer"
          name="field25479"
        />
        <input
          *ngIf="item.type === 'date' && item.visible === true"
          [formControlName]="item.name"
          value="{{ item.name }}"
          class="date value"
          type="date"
          name="field25479"
        />
        <select
          class="select-one"
          [formControlName]="item.name"
          *ngIf="
            item.type === 'string' &&
            item.visible === true &&
            item.dropdown === true
          "
        >
          <option
            *ngFor="let dropValue of item.dropdowns; index as i"
            [ngValue]="dropValue">
            {{ dropValue }}
          </option>
        </select>
      </li>
    </ul>
  </ng-container>
</form>
<!-- <div class="main">
  <div class="actions">
    <a>Save</a>
    <a
    (click)="closeRightpanel()"
    [tooltip]="mapService.templatetoolTips['close_right_panel']"
    [options]="myOptions15"
  >
    <img
      class="closer-img common-btns"
      src="/assets/img/tools/close-pv3.png"
      alt="closer"
  /></a>
  </div>
</div> -->
<div class="btn">
  <a
    class="closer button"
    type="submit"
    [tooltip]="save"
    [options]="myOptions13"
  >
  <button (click)="create()" type="button" class="saveBtn">Save</button>
    </a>
  <a
    class="closer button"
    [tooltip]="mapService.templatetoolTips['close_right_panel']"
    [options]="myOptions15"
  >
    <img
    (click)="closeRightpanel()"
      class="closer-img common-btns"
      src="/assets/img/tools/close-pv3.png"
      alt="closer"
  /></a>
</div>
<ngx-spinner [fullScreen]="true" type="" size="medium" bdColor="rgba(0, 0, 0, 0)">
  <p class="loading" > <img src="/assets/img/wheel.svg" alt="Girl in a jacket" width="100px" height="100px" > </p>
  </ngx-spinner>
